import axios from "axios";

export default axios.create({
  baseURL: "https://server.msosidrop.co.tz:7100/api/v1",
});

// export default axios.create({
//   baseURL: 'http://localhost:3200/api',
// });
